import { ISbStoryData } from 'storyblok';

import { ArtistStoryblok } from '../types/generated-storyblok';
import { ReleasePage, ReleasePageData } from '../types/ReleaseContentType';
import { formatArtistNames } from './artists';

export const getReleasePageData = ({
  content: { article, relatedArtists, title },
}: ReleasePage): ReleasePageData => {
  const resolvedArtists = (relatedArtists || [])
    .filter((item) => !!item.artist && typeof item.artist !== 'string')
    .map(({ artist }) => {
      const a = artist as ISbStoryData<ArtistStoryblok>;
      return {
        content: {
          name: a.content.name,
          thumbnail: a.content.thumbnail,
        },
        full_slug: a.full_slug,
        slug: a.slug,
      };
    })
    .filter(
      (
        item,
      ): item is typeof item & {
        content: {
          name: string;
          thumbnail: NonNullable<typeof item.content.thumbnail>;
        };
      } => !!item.content.name && !!item.content.thumbnail,
    );

  const artistNames = formatArtistNames(
    resolvedArtists.map((artist) => artist.content.name),
  );

  return {
    artistName: artistNames,
    hasProducts:
      (article || [])
        .filter(({ component }) => component === 'productList')
        .filter((ids) => (ids as ProductIds).products.length > 0).length > 0,
    resolvedArtists,
    title: `Avant Arte x ${title || artistNames}`,
  };
};
